import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Rocket, Sparkles } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const V = '#7FB342';

// Honest early-stage banner — no fake numbers.
// Replaces the dangerous "fake rating" approach with authentic pioneer framing.
const LaunchBanner = memo(() => {
  const { t } = useTranslation();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div
      className="w-full py-2 px-3 text-center text-[11px] sm:text-xs font-medium flex items-center justify-center gap-1.5 sm:gap-2"
      style={{
        background: isDark
          ? `linear-gradient(90deg, rgba(30,91,224,0.18), rgba(0,217,255,0.18))`
          : `linear-gradient(90deg, rgba(30,91,224,0.1), rgba(0,217,255,0.1))`,
        borderBottom: `1px solid ${isDark ? 'rgba(30,91,224,0.25)' : 'rgba(30,91,224,0.2)'}`,
        color: isDark ? '#F0EFFF' : '#1A1A2E'
      }}
      data-testid="launch-banner"
    >
      <Rocket className="h-3 w-3 sm:h-3.5 sm:w-3.5 shrink-0" style={{ color: V }} />
      <span className="truncate">
        <strong>{t('launch_banner.title', 'Lancement officiel')}</strong>
        {' — '}
        <span className="hidden sm:inline">{t('launch_banner.desc', 'Sois parmi les premiers pionniers. Prix fondateur 1,99€/mois garanti à vie.')}</span>
        <span className="sm:hidden">{t('launch_banner.desc_short', 'Prix fondateur 1,99€/mois à vie')}</span>
      </span>
      <Sparkles className="h-3 w-3 sm:h-3.5 sm:w-3.5 shrink-0" style={{ color: V }} />
    </div>
  );
});

LaunchBanner.displayName = 'LaunchBanner';
export default LaunchBanner;
